import { useMemo } from 'react'

import { useMenu } from './useMenu'

/**
 * Hook to fetch dashboard configuration from Menu Management
 *
 * @param {string} dashboardKey - Key prefix to filter menu items (e.g., 'advisor', 'dashboard')
 * @param {string} languageCode - Language code for translations (default: 'en')
 * @returns {object} - { menuItems, loading, error }
 *
 * This hook fetches all DASHBOARD menu items and filters them by the dashboardKey prefix.
 * For example:
 * - dashboardKey='advisor' matches: advisor.summary, advisor.client-funds
 * - dashboardKey='dashboard' matches: dashboard.home, dashboard.activity
 */
export function useDashboard(dashboardKey, languageCode = 'en') {
  const { menuItems: allItems, loading, error } = useMenu('DASHBOARD', languageCode)

  // Filter items by dashboard key prefix
  // Match items that start with the dashboard key
  // e.g., 'advisor' matches 'advisor.summary', 'advisor.client-funds'
  const menuItems = useMemo(() => {
    if (!allItems || !dashboardKey) return []
    return allItems.filter((item) => item.key.startsWith(`${dashboardKey}.`))
  }, [allItems, dashboardKey])

  return {
    menuItems,
    loading,
    error,
  }
}
